// Example: src/pages/Projects/AllProjects.js
import React from 'react';
import { Box, Typography, Paper } from '@mui/material';
import DashboardLayout from '../../layout/DashboardLayout';
import { Icon } from '../../icons';
import { COLORS, FONT_FAMILY, TYPOGRAPHY } from '../../constants/color';

const AllProjects = () => {
  return (
    <Box>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 4 }}>
        <Icon name="projects" sx={{ fontSize: 32, color: COLORS.PRIMARY }} />
        <Typography
          sx={{
            fontFamily: FONT_FAMILY,
            ...TYPOGRAPHY.H2,
            color: COLORS.TEXT,
          }}
        >
          All Projects
        </Typography>
      </Box>
      
      <Paper sx={{ p: 4 }}>
        <Typography
          sx={{
            fontFamily: FONT_FAMILY,
            ...TYPOGRAPHY.BODY_STANDARD,
            color: COLORS.MUTED_TEXT,
          }}
        >
          All projects content coming soon...
        </Typography>
      </Paper>
    </Box>
  );
};

export default AllProjects;